import { format, subDays, subYears } from "date-fns";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function ImportWhatsAppSettings({ values, setFieldValue, filas }) {
  const agora = format(new Date(), "yyyy-MM-dd'T'HH:mm");
  const alternar = (ligado) => {
    setFieldValue("importHistory", ligado);
    if (ligado) {
      setFieldValue("importTicketStatus", "pending");
      setFieldValue("importSessionGap", 0);
      if (!values.importStartDate) setFieldValue("importStartDate", format(subDays(new Date(), 1), "yyyy-MM-dd'T'HH:mm"));
      if (!values.importEndDate) setFieldValue("importEndDate", agora);
    }
  };
  return <div className="space-y-4 rounded border p-4">
    <div className="flex flex-wrap items-center gap-5">
      <Label className="flex items-center gap-2"><Switch checked={Boolean(values.importHistory)} onCheckedChange={alternar} />Importar mensagens do aparelho</Label>
      {values.importHistory && <>
        <Label className="flex items-center gap-2"><Switch checked={Boolean(values.importGroups)} onCheckedChange={v => setFieldValue("importGroups", v)} />Importar mensagens de grupo</Label>
        <Label className="flex items-center gap-2"><Switch checked={Boolean(values.closedTicketsPostImported)} onCheckedChange={v => setFieldValue("closedTicketsPostImported", v)} />Encerrar tickets após importação</Label>
      </>}
    </div>
    {values.importHistory && <>
      <div className="grid grid-cols-2 gap-3">
        <Label className="space-y-2">Data de início da importação<Input type="datetime-local" required min={format(subYears(new Date(), 2), "yyyy-MM-dd'T'HH:mm")} max={values.importEndDate || agora} value={values.importStartDate || ""} onChange={e => setFieldValue("importStartDate", e.target.value)} /></Label>
        <Label className="space-y-2">Data final da importação<Input type="datetime-local" required min={values.importStartDate || ""} max={agora} value={values.importEndDate || ""} onChange={e => setFieldValue("importEndDate", e.target.value)} /></Label>
      </div>
      <Label className="block space-y-2">Fila para importar mensagens
        <Select value={String(values.importQueueId || "none")} onValueChange={v => setFieldValue("importQueueId", v === "none" ? "" : v)}>
          <SelectTrigger><SelectValue /></SelectTrigger><SelectContent>
            <SelectItem value="none">Sem fila</SelectItem>
            {filas.map(f => <SelectItem key={f.id} value={String(f.id)}>{f.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </Label>
    </>}
  </div>;
}
